// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fh29Vf {
  align-items: baseline;
  display: flex;
  flex-direction: row;
  padding: var(--spacing-2);
  gap: var(--spacing-2);
  font-family: var(--font-family-base);
  color: var(--text-neutral-dark);
  border-radius: var(--radius-s);
  background-color: var(--surface-neutral-pale);
}

.h7EUEa {
  background-color: var(--surface-primary-subtle);
}

.VtleQ6 {
  flex: 1;
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
}

.rQZ_rg {
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  margin: 0;
}

.EdDy5n {
  display: flex;
  gap: var(--spacing-2);
}

.jG4IWG {
  align-items: center;
  display: flex;
  height: var(--spacing-3);
  justify-content: center;
  padding: 0;
  width: var(--spacing-3);
}

.XXefTJ {
  color: var(--text-neutral-stronger);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/AddressListItem/AddressListItem.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,wCAAwC;EACxC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".addressListItem {\n  align-items: baseline;\n  display: flex;\n  flex-direction: row;\n  padding: var(--spacing-2);\n  gap: var(--spacing-2);\n  font-family: var(--font-family-base);\n  color: var(--text-neutral-dark);\n  border-radius: var(--radius-s);\n  background-color: var(--surface-neutral-pale);\n}\n\n.isPrimary {\n  background-color: var(--surface-primary-subtle);\n}\n\n.address {\n  flex: 1;\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n}\n\n.addressTitle {\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.addressActions {\n  display: flex;\n  gap: var(--spacing-2);\n}\n\n.buttonAction {\n  align-items: center;\n  display: flex;\n  height: var(--spacing-3);\n  justify-content: center;\n  padding: 0;\n  width: var(--spacing-3);\n}\n\n.isSaving {\n  color: var(--text-neutral-stronger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addressListItem": `Fh29Vf`,
	"isPrimary": `h7EUEa`,
	"address": `VtleQ6`,
	"addressTitle": `rQZ_rg`,
	"addressActions": `EdDy5n`,
	"buttonAction": `jG4IWG`,
	"isSaving": `XXefTJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
